import { useContext } from 'react';

import ValidationContext, { ValidationValues } from './context';

const useValidation = (): ValidationValues => useContext(ValidationContext);

export default useValidation;
